module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nhqJov/tc-custom/9781637474167.jpg?1728851752476",
      "alt": "This image is the cover for the book McKinley"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("McKinley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Komarov eyed the person in front of him with determination; he would soon get her to stop smiling. Mac was surprised that Komarov even knew her name; she had imagined that he thought she was called ‘That Girl.' “The reason you are here is simple. You are to be the Village Witch. Do you have any questions?” Sascha and Anya mentally braced themselves, staring down at their shoes. “Oh, yes, I do, actually; thank you for asking.”Mac's expression was serious and sincere, even respectful. The other two did not dare look up, not even for a second. “I absolutely loved every minute I spent with this book - McKinley is such a wonderful character, and it's an interesting and quirky storyline, fast-paced and emotionally captivating... really, really great.” –Fiona Rom - Editor")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharlene Frances\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sharlene Frances recently moved from South Africa to amazing, mystical Alaska. She started writing during the COVID lockdown (others learned to bake bread). Sharlene Frances loves telling stories. “The only problem is that the characters tend to take on a life of their own, and the story is not even close to what was initially planned. As in real life, I go with the flow and hope we all come out alive at the other end!”")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Publication Consultants\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0